import localforage from 'localforage';
import { ref } from 'vue';
import { defineStore } from 'pinia';

import type { Client } from '../utils/types';
import { clientsService } from '../utils/api/clientsService';

export const useClientsStore = defineStore(
  'clienst',
  () => {
    const data = ref<Client[] | null>(null);

    async function getClientsFromLocalforage() {
      await localforage.getItem<Client[]>('clients');
    }

    async function fetch() {
      await getClientsFromLocalforage();

      if (data.value) return;

      data.value = await clientsService.getClients();
    }

    function addClient(client: Client) {
      const previousClients = data.value || [];

      data.value = [client, ...previousClients];
    }

    function editClient(editedClient: Client) {
      if (!data.value) {
        throw Error('Nie wczytano klientów');
      }

      data.value = data.value.map((client) => {
        if (client.uuid === editedClient.uuid) {
          return editedClient;
        }

        return client;
      });
    }

    function getClientByUuid(clientUuid: string) {
      if (!data.value) return null;

      const foundClient = data.value.find((client) => client.uuid === clientUuid);

      if (!foundClient) return null;

      return foundClient;
    }

    function invalidate() {
      data.value = null;

      fetch();
    }

    function removeClientById(id: number) {
      if (!data.value) return;

      data.value = data.value.filter((client) => client.id !== id);
    }

    return {
      data,
      fetch,
      invalidate,
      addClient,
      getClientByUuid,
      editClient,
      removeClientById,
    };
  },
  {
    // @ts-ignore
    persist: true,
  }
);
